import { render, staticRenderFns } from "./ExternalModal.vue?vue&type=template&id=0e0a876d&scoped=true&"
import script from "./ExternalModal.vue?vue&type=script&lang=js&"
export * from "./ExternalModal.vue?vue&type=script&lang=js&"
import style0 from "./ExternalModal.vue?vue&type=style&index=0&id=0e0a876d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0a876d",
  null
  
)

export default component.exports